import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { AiFillLinkedin, AiFillInstagram, AiFillGithub, AiOutlineComment  } from "react-icons/ai";
import 'swiper/swiper.css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-fade';
import Button from './Button';

function HeaderCTA() {
    const outsideLinks = [{
        key: 'Github',
        link: 'https://github.com/PierreMinet',
        icon: <AiFillGithub />,
    },
    {
        key: 'Linkedin',
        link: 'https://www.linkedin.com/in/pierre-minet-853450369',
        icon: <AiFillLinkedin />,
    },
    {
        key: 'Instagram',
        link: 'https://www.instagram.com/pierrem.designs',
        icon: <AiFillInstagram />,
    }];
    const displayOutsideLinks = outsideLinks.map(ol => {
        return <Button key={ol.key} link={ol.link} label={ol.key} icon={ol.icon}/>
    })
    return (
        <div className="landing-div">
            <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            spaceBetween={50}
            slidesPerView={1}
            navigation
            grabCursor={true}
            loop={true}
            pagination={{ dynamicBullets: true, }}
            >
            <SwiperSlide className='cta-slide'>
                <div className='slide-half'>
                    <h1>Junior Front-End Developer</h1>
                    <h2>Experienced Graphic Designer</h2>
                    <p className="cta-p">Designing websites, advertisements, social media content, music artworks, book covers and more. Let me help you turn your ideas into a catchy and modern visual.</p>
                </div>
                <div className='separator'></div>
                <div className='cta-socials'>
                    <p className='links-header'>FOLLOW ME ON</p>
                    <ul className='cta-slide-links'>
                        {displayOutsideLinks}
                    </ul>
                </div>
            </SwiperSlide>
            <SwiperSlide className='cta-slide'>
                <div className='slide-half'>
                    <h3>Creating seamless single page applications</h3>
                    <p className="cta-p">Single page applications are the websites of today and tomorrow : limiting the amount of HTTP requests, this type of website allows you for a more modular and interactive use of the web.</p>
                </div>
                <div className='separator'></div>
                <div className='cta-socials'>
                    <p className='links-header'>LEARN MORE</p>
                    <Button label='Go To Projects' route='/projects' className='basic-button' />
                </div>
            </SwiperSlide>
            <SwiperSlide className='cta-slide'>
                <div className='slide-half'>
                    <h3>Modern and engaging designs</h3>
                    <p className="cta-p">A good design often reflects a good product : looks matter, and your next customer, follower, supporter knows it.</p>
                    <p className='cta-p cta-p-sep'>Wether it is a logo, a promotionnal asset, an artwork or even a complete branding, we will discuss together how we can push your visual identity to the next level.</p>
                </div>
                <div className='separator'></div>
                <div className='cta-socials'>
                    <p className='links-header'>LEARN MORE</p>
                    <Button label='Go To Designs' route='/designs' className='basic-button' />
                </div>
            </SwiperSlide>
            <SwiperSlide className='cta-slide'>
                <div className='slide-half'>
                    <h3>Make it move</h3>
                    <p className="cta-p">The human brain is naturally attracted to movement, and for as long as it moves, we keep on watching.</p>
                    <p className='cta-p cta-p-sep'>Animations are a great way to catch the attention, it is an important tool to promote a product, an event, a release, or even a service.</p>
                </div>
                <div className='separator'></div>
                <div className='cta-socials'>
                    <p className='links-header'>LEARN MORE</p>
                    <Button label='Go To Designs' route='/designs' className='basic-button' />
                </div>
            </SwiperSlide>
            <SwiperSlide className='cta-slide'>
                <div className='slide-half'>
                    <h3>A wide range of possibilities</h3>
                    <p className="cta-p">From independent artists to record labels, collectives, companies, and authors, my goal is to help my collaborators to build a consistent strategy that will emphasize the essence of what they are standing for.</p>
                    <p className='cta-p cta-p-sep'>We will work together from the brainstorming process to a final product that will reflect your values and your work.</p>
                </div>
                <div className='separator'></div>
                <div className='cta-socials'>
                    <p className='links-header'>WANT TO WORK WITH ME ?</p>
                    <Button label="Let's Talk" route='/contact' className='cta-button' icon=<AiOutlineComment /> />
                </div>
            </SwiperSlide>
            </Swiper>
        </div>
    )
}

export default HeaderCTA;